export default {
  topTiles: [
    {
      company: 'FinTech250',
      height: '136px',
      width: '100px',
      naturalHeight: 136,
      naturalWidth: 100,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/fintech-250-logo-v2.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Inc',
      height: '151px',
      width: '240px',
      centered: true,
      naturalHeight: 100,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/Inc_2021_BestWorkplaces_StandardLogo_304x200',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: 'People',
      height: '148px',
      width: '100px',
      naturalHeight: 148,
      naturalWidth: 100,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/2020-companies-that-care.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Bay Area 2021',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/FortuneBayArea2021.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Financial Services 2021',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/FortuneBestFinancialServices2021.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Women',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/FortuneBestWomen.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  bottomTiles: [
    {
      company: 'Most Creative People',
      height: '130px',
      width: '104px',
      naturalHeight: 130,
      naturalWidth: 104,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/FC MostCreativePeople_2021_ StandardLogo.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Smart Money Awards',
      height: '131px',
      width: '131px',
      naturalHeight: 131,
      naturalWidth: 131,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/SmartMoneyAwards2021-seal.png',
      customTileStyle: 'press-logo-columns-6 wide',
    },
    {
      company: 'Fair Pay Workplace',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/Fair-pay-workplace.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
};
